module.exports = __webpack_public_path__ + "img/image_2020-05-11_20-44-57.85122eca.png";